import {autobind} from 'core-decorators';

import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

import {subscribe} from '../../../replete';


import {CustomComponent, Link} from '../../common/components';
import {Icon} from '../../common/components/Icon';
import {ToggleMenu} from '../../common/components/ToggleMenu';

import './NavBar.scss';
import '~/assets/scss/transformicons.scss';


@subscribe({
    auth: ['api.auth'],
})
export class NavBar extends CustomComponent {
    @autobind
    logout() {
        this.context.authService.logout({});
    }
    @autobind
    registerSigninButtonTapEvent() {
        this.context.apiService.registerEvent('signin_button_tap', {});
    }
    render() {
        const gettextSub = this.context.gtService.gettextSub;

        const loggedIn = this.context.authService.isLoggedIn();
        let loggedInMenu = null;
        if (loggedIn) {
            loggedInMenu = (<ToggleMenu className="navbar-icon profile" menu={
                <div className="animated">
                    <Link className="item" to={this.linkToProfile()}>
                        <div className="username">{ this.context.authService.getUsername() }</div>
                        <div className="subheading">view profile</div>
                    </Link>
                    {this.context.authService.userHasFlag('developer') &&
                        <Link className="item" to="/developer/dashboard">
                            {gettextSub('Developer Dashboard')}
                        </Link>
                    }
                    <a className="item" onClick={this.logout}>Log out</a>
                </div>}>
                <Icon name="profile-icon"/>
            </ToggleMenu>);
        }

        return (
            <nav className="NavBar">
                <div className="container">
                    <span itemScope={true} itemType="http://schema.org/Organization">
                        <Link to="/developer/dashboard" className="navbar-brand" itemProp="url">
                            <img src="/assets/img/tenor-logo.svg" width="80" height="22" alt="Tenor logo" itemProp="logo"/>
                            <div className='navbar-brand-text'>Developer</div>
                        </Link>
                    </span>
                    <div className="nav-buttons">
                        <div className="account-buttons">
                            <Link className="api-docs-link" external={true} to="/gifapi" style={{'line-height': '32px', 'color': 'gray'}}>→ API Documentation</Link>
                            { loggedIn && loggedInMenu }

                            { !loggedIn && <Link className="white-button" to="/developer/dashboard" onClick={this.registerSigninButtonTapEvent}>SIGN IN</Link> }
                        </div>
                    </div>
                </div>
            </nav>
        );
    }
}
